export enum Tab {
  ReadingLogs = 'ReadingLogs',
  PatientSummary = 'PatientSummary',
  ProgramSummary = 'ProgramSummary',
  BillingReport = 'BillingReport',
  PayrollReport = 'PayrollReport',
}

export enum DateRangeType {
  Week = 'Week',
  Month = 'Month',
}
